import React from 'react'
import { icon } from '../../../services/icon'

const Error = () => {
    return (
        <div id="baseo_comarquage">
            <div className="baseocom-flex baseocom-gap-5 baseocom-text-lg baseocom-flex-col">
                Ooops, une erreur est survenue
                <button
                    onClick={() => window.location.reload()}
                    className="baseocom-btn-purple baseocom-flex baseocom-items-center baseocom-fill-white baseocom-gap-3 baseocom-w-max"
                >
                    {icon('refresh')} Actualiser la page
                </button>
            </div>
        </div>
    )
}

export default Error
